const API = {
  GET_FETCH_TENANT: {
    path: '/ent-meta',
    method: 'GET',
  },
  GET_RELATED_SKILLS: {
    path: '/skills/all',
    method: 'GET',
  },
  GET_USER_NOTIFICATIONS: {
    path: '/user/notifications',
    method: 'GET',
  },
  GET_PLUGINS: {
    path: '/plugins/tenant',
    method: 'GET',
  },
};
export default API;
